export function getEnv(env: string): string {
  const value = import.meta.env[env];
  if (value === undefined) {
    throw new Error(`Environment variable ${env} is undefined`);
  }
  return value;
}

export function getEnvNumber(env: string): number {
  const value = import.meta.env[env];
  if (value === undefined) {
    throw new Error(`Environment variable ${env} is undefined`);
  }
  const numValue = Number(value);
  if (isNaN(numValue)) {
    throw new Error(`Environment variable ${env} is not a valid number`);
  }
  return numValue;
}

export function getEnvBoolean(env: string): boolean {
  const value = import.meta.env[env];
  if (value === undefined) {
    throw new Error(`Environment variable ${env} is undefined`);
  }
  const boolValue = value === "true";
  return boolValue;
}
